import { useSessionContext } from 'src/contexts';
import { msalInstance } from 'src/pages/auth/auth.axios.instance/auth.axios.instance';

export const useAuth = () => {
  const [session, setSession] = useSessionContext();

  return {
    setAuthSession: ({
      accessToken,
      refreshToken,
      accessTokenTime,
    }: {
      accessToken: string;
      refreshToken?: string;
      accessTokenTime?: string;
    }) => {
      setSession({ ...session, isAuthenticated: !!accessToken, accessToken });

      localStorage.setItem('token', accessToken);

      if (refreshToken) localStorage.setItem('refreshToken', refreshToken);
      if (accessTokenTime) localStorage.setItem('tokenTime', accessTokenTime);
    },
    logout: () => {
      setSession({ ...session, isAuthenticated: false, accessToken: '' });

      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('tokenTime');

      const isLoggedIn = msalInstance.getAllAccounts().length > 0;

      if (isLoggedIn) {
        msalInstance.logoutPopup();
      }
    },
  };
};
